<div class="w-full py-3 px-4">

  <div class="flex justify-end">
    <a href="#"
      class="flex items-center w-28 px-4 py-1 rounded-[5px] border border-[#BB0000] bg-[#BB0000] text-white text-sm lg:text-base
             hover:bg-white hover:text-[#BB0000] hover:shadow-lg">
      <img class="w-4 h-4 mr-2" src="/assets/images/stock/youtube.png" alt="youtube" />
      Help
    </a>

</div><div class="flex justify-center items-center min-h-[100px] py-8">
  <div class="flex flex-wrap gap-x-8 gap-y-6">


    <div class="flex items-center">
      <div class="relative">
        <input type="text" id="start_range_1" class="block px-20 py-4.5 w-full text-base text-gray-800 bg-gradient-to-r from-white via-yellow-50 to-white
                 rounded-l-md rounded-r-none border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0
                 focus:border-[#c19725] peer shadow-sm" placeholder=" " />
        <label for="start_range_1" class="absolute text-base text-[#898989] duration-300 transform -translate-y-5 scale-90 top-3 z-0 bg-white px-2
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                 peer-focus:top-3 peer-focus:scale-90 peer-focus:-translate-y-5 start-1">
          ADD PRODUCT ID / BARCODE / RFID
        </label>
      </div>


      <button type="submit" class="px-5 py-4 rounded-r-md rounded-l-none border border-[#C19725] bg-[#C19725] text-white
      text-base xl:text-lg font-bold capitalize text-center
      hover:bg-white hover:text-[#C19725] hover:shadow-lg
      transition-shadow shadow-sm focus:ring-0 focus:outline-none">
        GO
      </button>
    </div>


    <div class="flex items-center">
      <div class="relative">
        <input type="text" id="start_range_2" class="block px-20 py-4.5 w-full text-base text-gray-800 bg-gradient-to-r from-white via-yellow-50 to-white
                 rounded-l-md rounded-r-none border border-[#DCDCDC] appearance-none focus:outline-none focus:ring-0
                 focus:border-[#c19725] peer shadow-sm" placeholder=" " />
        <label for="start_range_2" class="absolute text-base text-[#898989] duration-300 transform -translate-y-5 scale-90 top-3 z-0 bg-white px-2
                 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2
                 peer-focus:top-3 peer-focus:scale-90 peer-focus:-translate-y-5 start-1">
          RETURN PRODUCT ID / BARCODE / RFID
        </label>
      </div>


      <button type="submit" class="px-5 py-4 rounded-r-md rounded-l-none border border-[#C19725] bg-[#C19725] text-white
      text-base xl:text-lg font-bold capitalize text-center
      hover:bg-white hover:text-[#C19725] hover:shadow-lg
      transition-shadow shadow-sm focus:ring-0 focus:outline-none">
        GO
      </button>
    </div>

  </div>
</div>
</div>
